import { jsx as _jsx } from "react/jsx-runtime";
import { Typography as MuiTypography, } from '@mui/material';
import { forwardRef } from 'react';
export const Typography = forwardRef(function Typography({ children, ...props }, ref) {
    return (_jsx(MuiTypography, { ref: ref, ...props, children: children }));
});
